import { Box } from "@mui/material"
import ForestMedallionItem from "../inventory/medallions/ForestMedallionItem"
import FireMedallionItem from "../inventory/medallions/FireMedallionItem"
import WaterMedallionItem from "../inventory/medallions/WaterMedallionItem"
import ShadowMedallionItem from "../inventory/medallions/ShadowMedallionItem"
import SpiritMedallionItem from "../inventory/medallions/SpiritMedallionItem"
import LightMedallionItem from "../inventory/medallions/LightMedallionItem"
import TrialsBackground from "../../core/assets/rsl/trials.png"


export enum TrialEnum{
    Forest,
    Fire,
    Water,
    Shadow,
    Spirit,
    Light
}
interface ReworkTrialTrackerProps {
    trialActivated: boolean
    forestActivated: boolean,
    fireActivated: boolean,
    waterActivated: boolean,
    shadowActivated: boolean,
    spiritActivated: boolean,
    lightActivated: boolean,
    setTrial: (trial: TrialEnum, value: boolean) => void
}

const ReworkTrialTracker = (props: ReworkTrialTrackerProps) => {

    if(!props.trialActivated)
        return <></>
    return <Box display={"flex"} height={60} width={225} justifyContent={"center"} sx={{backgroundImage: `url(${TrialsBackground})`}}>
        <ForestMedallionItem hideLabel isObtained={props.forestActivated} setIsObtained={(v) => props.setTrial(TrialEnum.Forest, !props.forestActivated)} />
        <FireMedallionItem hideLabel isObtained={props.fireActivated} setIsObtained={(v) => props.setTrial(TrialEnum.Fire, !props.fireActivated)}/>
        <WaterMedallionItem hideLabel isObtained={props.waterActivated} setIsObtained={(v) => props.setTrial(TrialEnum.Water, !props.waterActivated)}/>
        <ShadowMedallionItem hideLabel isObtained={props.shadowActivated} setIsObtained={(v) => props.setTrial(TrialEnum.Shadow, !props.shadowActivated)}/>
        <SpiritMedallionItem hideLabel isObtained={props.spiritActivated} setIsObtained={(v) => props.setTrial(TrialEnum.Spirit, !props.spiritActivated)}/>
        <LightMedallionItem hideLabel isObtained={props.lightActivated} setIsObtained={(v) => props.setTrial(TrialEnum.Light, !props.lightActivated)}/>
    </Box>
}

export default ReworkTrialTracker